import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'rh_onboarding_last_shown';

function shouldShow() {
  const last = localStorage.getItem(STORAGE_KEY);
  if (!last) return true;
  return Date.now() - parseInt(last, 10) > 24 * 60 * 60 * 1000;
}

export default function OnboardingPopup() {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
  if (shouldShow()) {
    setVisible(true);
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    const fadeTimer = setTimeout(() => setFading(true), 4600);
    const hideTimer = setTimeout(() => {
      setVisible(false);
      setFading(false);
    }, 5000);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }
}, []);

  const dismiss = () => {
    setFading(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div
  className={`ob-backdrop ${fading ? 'ob-backdrop--out' : ''}`}
  style={{ pointerEvents: fading ? 'none' : 'all' }}
  onClick={dismiss}
>

      <div
  className={`ob-card ${fading ? 'ob-card--out' : ''}`}
  onClick={e => e.stopPropagation()}
>
        <button className="ob-close" onClick={dismiss}>✕</button>
        <p className="ob-eyebrow">The Radiant Horizon</p>
        <h2 className="ob-headline">
          200+ Grains.<br />
          One for every nation.<br />
          Add yours.
        </h2>
        <p className="ob-sub">
          No login required. One grain per day.
        </p>
        <div className="ob-bar">
          <div className={`ob-bar-fill ${fading ? '' : 'ob-bar-fill--running'}`} />
        </div>
      </div>
    </div>
  );
}